import React from 'react';
export const ProductSection: React.FC = () => {
  return <section className="bg-[#F5F5EB] py-20 px-5 text-center" data-id="element-230" data-mp="1hvfsy5tdzjph">
      <div className="inline-block bg-gradient-to-br from-brown-mid to-brown-light text-white py-[7px] px-[22px] rounded-full text-xs font-sans font-bold tracking-[2px] uppercase mb-[15px]" data-id="element-231" data-mp="2vf7szqr9z9w">
        🏗️ MEGA PACK TIERRA VIVA™
      </div>
      <h2 className="text-[clamp(24px,4vw,42px)] text-[#1A1A1A] mb-2 leading-[1.2]" data-id="element-232" data-mp="cqguloxk6p9b">
        3 Tomos + 4 Bonos — Del Suelo a la Llave
      </h2>
      <p className="text-base text-[#777] font-sans mb-[35px]" data-id="element-233" data-mp="mj4pge4zaj5e">
        150 páginas técnicas. Todo resuelto. Sin buscar. Sin improvisar. Sin
        perder domingos.
      </p>

      <div className="flex justify-center flex-wrap gap-2 mb-[30px]" data-id="element-234" data-mp="vjay9mpqeuy8">
        <span className="py-2 px-5 rounded-full text-[13px] font-sans font-bold cursor-pointer border-2 border-transparent transition-all duration-200 bg-brown-mid text-white" data-id="element-235" data-mp="vgyj1hbcyyov">
          📗 Tomo 1
        </span>
        <span className="py-2 px-5 rounded-full text-[13px] font-sans font-bold cursor-pointer border-2 border-transparent transition-all duration-200 bg-green-mid text-white" data-id="element-236" data-mp="2xcr2xninmac7">
          📘 Tomo 2
        </span>
        <span className="py-2 px-5 rounded-full text-[13px] font-sans font-bold cursor-pointer border-2 border-transparent transition-all duration-200 bg-brown-dark text-white" data-id="element-237" data-mp="5cspl7u05mi1">
          📙 Tomo 3
        </span>
        <span className="py-2 px-5 rounded-full text-[13px] font-sans font-bold cursor-pointer border-2 border-brown-mid transition-all duration-200 bg-brown-mid/15 text-brown-mid" data-id="element-238" data-mp="f33vv115s7s3">
          🎁 4 Bonos
        </span>
      </div>

      <div className="grid grid-cols-[repeat(auto-fit,minmax(290px,1fr))] gap-[25px] max-w-[1050px] mx-auto mb-10" data-id="element-239" data-mp="p2362o1kobh7">
        {/* Tomo 1 */}
        <div className="rounded-2xl overflow-hidden shadow-[0_8px_35px_rgba(0,0,0,0.10)] bg-white transition-transform duration-300 hover:-translate-y-1.5 text-left" data-id="element-240" data-mp="t00w1t3631ln">
          <div className="py-7 px-6 pb-5 text-white bg-gradient-to-br from-[#7A3B10] to-[#A0522D]" data-id="element-241" data-mp="2uu8jg44l8k8h">
            <div className="text-[11px] font-sans font-bold tracking-[3px] uppercase opacity-75 mb-1.5" data-id="element-242" data-mp="1zru3286k7cb">
              📗 TOMO 1 — 50 PÁGINAS
            </div>
            <h3 className="text-xl mb-1.5 leading-[1.2]" data-id="element-243" data-mp="b0g0pbv8v5f6">
              La Ciencia del Suelo · Base Constructiva
            </h3>
            <p className="text-[13px] opacity-85 font-sans leading-[1.4]" data-id="element-244" data-mp="6xjk1qp9ljdv">
              El ADN de tu casa. Antes de poner la primera piedra, dominá tu
              material.
            </p>
          </div>
          <div className="py-[22px] px-6" data-id="element-245" data-mp="fyhr6hv0270o">
            <ul className="list-none p-0" data-id="element-246" data-mp="unnqs6xr1z93">
              {['Test del Frasco: Tu laboratorio de campo en 24h', 'Cómo leer y corregir tu tierra arcillosa', 'Inercia térmica vs. aislamiento: cuál necesitás', 'Orientación solar: calefacción de $0', 'Prueba de la cinta y la bola (plasticidad)', 'Plan de acción días 1 al 28'].map((item, i) => <li key={i} className="py-2 text-sm font-sans text-[#444] border-b border-[#F5F5F0] flex items-start gap-[9px] leading-[1.4] last:border-b-0" data-id="element-247" data-mp="yqadjtfkctzf" data-mpi={i}>
                  <span className="shrink-0 text-[13px]" data-id="element-248" data-mp="1i9hi6w9257io">✅</span> {item}
                </li>)}
            </ul>
          </div>
          <div className="px-6 pb-[22px] flex justify-between items-center" data-id="element-249" data-mp="19b5lqdliffib">
            <span className="bg-[#F5F0E8] text-brown-mid py-1 px-3.5 rounded-full text-xs font-sans font-bold" data-id="element-250" data-mp="1dc7oh4emy9p1">
              📄 50 Páginas Técnicas
            </span>
          </div>
        </div>

        {/* Tomo 2 */}
        <div className="rounded-2xl overflow-hidden shadow-[0_8px_35px_rgba(0,0,0,0.10)] bg-white transition-transform duration-300 hover:-translate-y-1.5 text-left" data-id="element-251" data-mp="14c1ehsi5brum">
          <div className="py-7 px-6 pb-5 text-white bg-gradient-to-br from-[#244D1E] to-[#2D5A27]" data-id="element-252" data-mp="pksgav06gy5v">
            <div className="text-[11px] font-sans font-bold tracking-[3px] uppercase opacity-75 mb-1.5" data-id="element-253" data-mp="ujdgwvjcdjuu">
              📘 TOMO 2 — 50 PÁGINAS
            </div>
            <h3 className="text-xl mb-1.5 leading-[1.2]" data-id="element-254" data-mp="ljqhgfa6ao4f">
              Ingeniería Estructural · Del Cimiento al Techo
            </h3>
            <p className="text-[13px] opacity-85 font-sans leading-[1.4]" data-id="element-255" data-mp="dm6njoa7z45u">
              Levantá una estructura que dure 300 años y baile con los sismos
              sin romperse.
            </p>
          </div>
          <div className="py-[22px] px-6" data-id="element-256" data-mp="3vybgqu81z7hv">
            <ul className="list-none p-0" data-id="element-257" data-mp="3vxjxmivn728h">
              {['Cimientos de piedra y cal: Las "botas" perfectas', 'Adobe y BTC: El ladrillo que respira', 'Quincha y Bahareque: Sistema antisísmico', 'Vigas corona: El cinturón de tu estructura', 'Colocación de marcos y pre-armados', 'Plan de obra días 29 al 56'].map((item, i) => <li key={i} className="py-2 text-sm font-sans text-[#444] border-b border-[#F5F5F0] flex items-start gap-[9px] leading-[1.4] last:border-b-0" data-id="element-258" data-mp="3h1kqpbk9r84x" data-mpi={i}>
                  <span className="shrink-0 text-[13px]" data-id="element-259" data-mp="1fa7mypu1f6ag">✅</span> {item}
                </li>)}
            </ul>
          </div>
          <div className="px-6 pb-[22px] flex justify-between items-center" data-id="element-260" data-mp="1b95km04tqe49">
            <span className="bg-[#F5F0E8] text-brown-mid py-1 px-3.5 rounded-full text-xs font-sans font-bold" data-id="element-261" data-mp="2t68xotp9cnrq">
              📄 50 Páginas Técnicas
            </span>
          </div>
        </div>

        {/* Tomo 3 */}
        <div className="rounded-2xl overflow-hidden shadow-[0_8px_35px_rgba(0,0,0,0.10)] bg-white transition-transform duration-300 hover:-translate-y-1.5 text-left" data-id="element-262" data-mp="32wlm4x071135">
          <div className="py-7 px-6 pb-5 text-white bg-gradient-to-br from-[#4A3A28] to-[#6B5540]" data-id="element-263" data-mp="2a74wu87ve0b5">
            <div className="text-[11px] font-sans font-bold tracking-[3px] uppercase opacity-75 mb-1.5" data-id="element-264" data-mp="2f5g3ka2vbup5">
              📙 TOMO 3 — 50 PÁGINAS
            </div>
            <h3 className="text-xl mb-1.5 leading-[1.2]" data-id="element-265" data-mp="2j9nveg4mhqrl">
              Acabados de Lujo · La Piel de tu Casa
            </h3>
            <p className="text-[13px] opacity-85 font-sans leading-[1.4]" data-id="element-266" data-mp="3umq8v2bfe07j">
              Transforma el barro en una vivienda premium que parece salida de
              una revista.
            </p>
          </div>
          <div className="py-[22px] px-6" data-id="element-267" data-mp="1zj0njmugxnkn">
            <ul className="list-none p-0" data-id="element-268" data-mp="1zhz0ek06hamk">
              {['Revoques de cal hidráulica: El escudo impermeable', 'Técnica del Bruñido con piedra de río', 'Tadelakt Marroquí: Impermeabilización milenaria', 'Suelos de tierra con aceite de linaza y cera', 'Pinturas naturales con pigmentos minerales', 'Plan de terminación días 57 al 90'].map((item, i) => <li key={i} className="py-2 text-sm font-sans text-[#444] border-b border-[#F5F5F0] flex items-start gap-[9px] leading-[1.4] last:border-b-0" data-id="element-269" data-mp="1gt26wiclum5e" data-mpi={i}>
                  <span className="shrink-0 text-[13px]" data-id="element-270" data-mp="1bvk2n59j8v3q">✅</span> {item}
                </li>)}
            </ul>
          </div>
          <div className="px-6 pb-[22px] flex justify-between items-center" data-id="element-271" data-mp="1qkopizr9vni6">
            <span className="bg-[#F5F0E8] text-brown-mid py-1 px-3.5 rounded-full text-xs font-sans font-bold" data-id="element-272" data-mp="1lqu7s1v89ilq">
              📄 50 Páginas Técnicas
            </span>
          </div>
        </div>
      </div>

      <div className="bg-gradient-to-br from-green-brand to-green-dark rounded-2xl py-[35px] px-10 max-w-[800px] mx-auto text-left md:px-[22px] md:py-[25px]" data-id="element-273" data-mp="t1dj9faqalus">
        <h3 className="text-gold-main text-lg font-sans font-bold mb-5 text-center" data-id="element-274" data-mp="39il9ncka5soq">
          ✅ Cada Tomo Incluye:
        </h3>
        <div className="grid grid-cols-[repeat(auto-fit,minmax(220px,1fr))] gap-3" data-id="element-275" data-mp="2vrzofh7ct6no">
          {['Plan de acción diario listo', 'Proporciones exactas de mezcla', 'Técnicas paso a paso con medidas', 'Diagnóstico y solución de patologías', 'Errores comunes y cómo evitarlos', 'Adaptación a climas fríos, cálidos y húmedos', '100% aplicable en Argentina y Latinoamérica', 'Alineado a normativas vigentes de bioconstrucción'].map((item, i) => <div key={i} className="flex items-center gap-2.5 text-sm font-sans text-[#C8E6C9]" data-id="element-276" data-mp="3jfpm2kobq9sc" data-mpi={i}>
              <span className="shrink-0 text-sm" data-id="element-277" data-mp="231hblogtvqx2">✅</span> {item}
            </div>)}
        </div>
      </div>
    </section>;
};